import Vue from "vue";
import { ApolloClient } from "apollo-client";
import { HttpLink } from "apollo-link-http";
import {
  InMemoryCache,
  IntrospectionFragmentMatcher,
} from "apollo-cache-inmemory";
import { ApolloLink, concat } from "apollo-link";
import VueApollo from "vue-apollo";
import {
  GT_AUTH_TOKEN,
  GT_ENDPOINT,
  GT_CONTENT_HUB_ENDPOINT,
  GT3_ENDPOINT,
  //REZG_ENDPOINT,
  //REZG_WSS_ENDPOINT
} from "./settings";

const httpLink = new HttpLink({
  uri: GT_ENDPOINT,
  credentials: "include",
});
// const rezGraphHttpLink = new HttpLink({
//   uri: REZG_ENDPOINT
// });
// const wsLink = new WebSocketLink({
//   uri: REZG_WSS_ENDPOINT,
//   options: {
//     reconnect: true
//   }
// });
// using the ability to split links, you can send data to each link
// depending on what kind of operation is being sent
// const link = split(
//   // split based on operation type
//   ({ query }) => {
//     const { kind, operation } = getMainDefinition(query);
//     return kind === "OperationDefinition" && operation === "subscription";
//   }
//   wsLink,
//   rezGraphHttpLink
// );
const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  operation.setContext({
    headers: {
      authorization: localStorage.getItem(GT_AUTH_TOKEN) || "",
    },
  });
  return forward(operation);
});

// Use IntrospectionFragmentMatcher so queries with union/interface fragments
// (e.g. ... on Markup { } ... on Commission { }) don't trigger the heuristic
// fragment matcher warning. Minimal introspection is enough to disable the heuristic.
const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: {
    __schema: {
      types: [],
    },
  },
});

// Create the apollo client
export const apolloClient = new ApolloClient({
  link: concat(authMiddleware, httpLink),
  cache: new InMemoryCache({ fragmentMatcher }),
  connectToDevTools: true,
});
// apollo reezGraph client
// no auth for now
// const apolloRezGClient = new ApolloClient({
//   link,
//   cache: new InMemoryCache(),
//   connectToDevTools: true
// });

//apollo gt-content-hub client
const gtContentLink = new HttpLink({
  uri: GT_CONTENT_HUB_ENDPOINT,
});
const apolloGtContentHubClient = new ApolloClient({
  link: gtContentLink,
  cache: new InMemoryCache({ fragmentMatcher }),
  connectToDevTools: true,
});
//apollo gt3 client
const gt3Link = new HttpLink({
  uri: GT3_ENDPOINT,
});
const apolloGt3Client = new ApolloClient({
  link: concat(authMiddleware, gt3Link),
  cache: new InMemoryCache({ fragmentMatcher }),
  connectToDevTools: true,
});
export const apolloProvider = new VueApollo({
  clients: {
    gtweb: apolloClient,
    gtContent: apolloGtContentHubClient,
    gt3: apolloGt3Client,
  },
  defaultClient: apolloClient,
});
Vue.use(VueApollo);

export default apolloProvider;



// WEBPACK FOOTER //
// ./src/constants/apollo-provider.js